// extracted by mini-css-extract-plugin
export var inputLabelContainer = "gH_n5";
export var inputsContainer = "gH_n4";